export default "__VITE_ASSET__DrbNO4EJ__"